import { render, staticRenderFns } from "./add-table.vue?vue&type=template&id=cfe30378&scoped=true"
import script from "./add-table.vue?vue&type=script&lang=js"
export * from "./add-table.vue?vue&type=script&lang=js"
import style0 from "./add-table.vue?vue&type=style&index=0&id=cfe30378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe30378",
  null
  
)

export default component.exports